import { render } from "./MapSwitch.vue?vue&type=template&id=5ffbdf67&scoped=true&ts=true"
import script from "./MapSwitch.vue?vue&type=script&lang=ts"
export * from "./MapSwitch.vue?vue&type=script&lang=ts"

import "./MapSwitch.vue?vue&type=style&index=0&id=5ffbdf67&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffbdf67"]])

export default __exports__